var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m932.38 178.63c0 52.262-42.293 94.633-94.465 94.633-52.168 0-94.461-42.371-94.461-94.633 0-52.266 42.293-94.633 94.461-94.633 52.172 0 94.465 42.367 94.465 94.633",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m916.82 392.27-121.03-106.14c-16.211-14.219-40.848-12.602-55.066 3.6016-14.207 16.211-12.613 40.859 3.6133 55.066l121.02 106.14c16.223 14.219 40.871 12.59 55.078-3.6133 14.219-16.188 12.598-40.836-3.6133-55.055z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m708.06 248.91-161.32 12.469c-21.602 1.668-37.789 20.531-36.156 42.145 1.6328 21.602 20.461 37.766 42.047 36.109l161.32-12.469c21.602-1.6797 37.789-20.531 36.156-42.145-1.6172-21.613-20.445-37.777-42.047-36.109z",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1043 277.86c-15.469-15-40.188-14.605-55.188 0.86328l-112.02 115.61c-15 15.48-14.605 40.176 0.86328 55.176 15.48 15 40.188 14.605 55.188-0.86328l112.02-115.61c15.012-15.469 14.617-40.176-0.86328-55.176z",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m562.55 275.43c-15.48-15-40.188-14.605-55.188 0.86328l-112.01 115.61c-15 15.48-14.617 40.176 0.86328 55.176 15.48 15 40.188 14.605 55.188-0.86328l112.02-115.61c14.988-15.469 14.605-40.176-0.875-55.176z",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m777.43 271.78-16.199-9.7578c-33.539-20.195-77.062-9.3242-97.223 24.277l-167.87 279.86c-20.16 33.602-9.3008 77.207 24.238 97.391l16.188 9.7422c33.539 20.207 77.074 9.3242 97.234-24.266l167.87-279.85c20.152-33.598 9.3047-77.203-24.234-97.398z",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m766.46 724.63-144.11-146.74c-23.773-24.227-62.652-24.539-86.832-0.71875-24.168 23.82-24.492 62.785-0.70703 87l144.1 146.73c23.773 24.227 62.652 24.527 86.82 0.70703 24.164-23.816 24.512-62.781 0.73047-86.984z",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m597.65 521.48c-28.355-18.625-66.227-10.586-84.574 17.953l-111.2 172.95c-18.348 28.559-10.246 66.793 18.121 85.43 28.355 18.625 66.227 10.586 84.574-17.965l111.2-172.95c18.348-28.551 10.246-66.793-18.121-85.418z",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m733.98 723.64c-29.375-5.6055-57.238 16.559-62.23 49.465l-40.91 269.53c-5.0039 32.93 14.746 64.152 44.125 69.742 29.375 5.5938 57.238-16.547 62.23-49.465l40.922-269.53c4.9922-32.914-14.773-64.141-44.137-69.742z",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m447.94 724.63-267-49.152c-32.605-6-64.668 10.883-71.605 37.727s13.871 53.461 46.488 59.473l267 49.152c32.605 6 64.68-10.883 71.617-37.727 6.9219-26.859-13.898-53.461-46.5-59.473z",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.9a9cca59bd72cc4506b9bb72f140302f.svg";
export { ForwardRef as ReactComponent };